import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { ApiService } from './api.service';
import { PaginateQuery, PaginateResult } from '../core';

export interface TimelineItem {
  logID: string;
  eventTime: string;
  description: string;
  relatedEntityType: string;
  relatedEntityId: string | null;
  oldValue?: string | null;
  newValue?: string | null;
  changedFields?: any;
}

@Injectable({ providedIn: 'root' })
export class TimelineService extends ApiService {
  constructor(http: HttpClient) {
    super(http, 'Timeline');
  }

  public getCustomerTimeline(paginateQuery: PaginateQuery): Observable<PaginateResult> {
    return this.http.post<PaginateResult>(`${this.route()}/Paginate/Customer`, paginateQuery).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          return of({ total: 0, list: [] });
        } else {
          throw error;
        }
      })
    );
  }

  paginateQuote(query: PaginateQuery): Observable<PaginateResult> {
    return this.http.post<PaginateResult>(`${this.route()}/Paginate/Quote`, query).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          return of({ total: 0, list: [] });
        } else {
          throw error;
        }
      })
    );
  }
}
